module.exports = __webpack_public_path__ + "img/bison.07553914.png";